import { ApiError } from './api.js';
import { TEXT } from './ui-text.js';

export const RESUME_TIMEOUT_MS = 10000;

export function isCriticalBootstrapError(error) {
  return error instanceof ApiError
    && (error.status === 403 || error.code === 'NETWORK' || error.code === 'TIMEOUT');
}

export function isResumeTimeout(error) {
  return error?.code === 'RESUME_TIMEOUT';
}

export function buildResumeTimeoutError() {
  const resumeError = new Error('Не удалось восстановить приложение за 10 секунд.');
  resumeError.code = 'RESUME_TIMEOUT';
  return resumeError;
}

export function withResumeWatchdog(promise, timeoutMs = RESUME_TIMEOUT_MS) {
  let timeoutId = null;
  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = globalThis.setTimeout(() => {
      reject(buildResumeTimeoutError());
    }, timeoutMs);
  });

  return Promise.race([promise, timeoutPromise])
    .finally(() => {
      if (timeoutId) {
        globalThis.clearTimeout(timeoutId);
      }
    });
}

export function describeBootstrapError(error) {
  if (isResumeTimeout(error)) {
    return TEXT.bootstrap.resumeFailed;
  }
  if (error instanceof ApiError && error.status === 403) {
    return TEXT.api.forbidden;
  }
  if (error instanceof ApiError && (error.code === 'TIMEOUT' || error.code === 'NETWORK')) {
    return TEXT.api.network;
  }
  return error?.message || TEXT.bootstrap.startFailed;
}

export function shouldShowResumeError(error, { hadBlockingScreen = false } = {}) {
  // Экран ошибки показываем только при холодном восстановлении (был блокирующий
  // экран загрузки/ошибки). Тёплый resume работающего приложения не должен ронять
  // экран — обновление состояния идёт в фоне, временные сбои /api терпимы.
  return hadBlockingScreen;
}

// Авто-ретрай экрана «Ошибка запуска»: 5с → 10с → 20с → 40с → кап 60с. Нестабильная
// сеть на холодном старте — приложение поднимается само, без ручного «Обновить».
const BOOTSTRAP_RETRY_DELAYS_MS = [5000, 10000, 20000, 40000, 60000];

export function nextBootstrapRetryDelay(attempt) {
  const index = Math.min(Math.max(attempt, 0), BOOTSTRAP_RETRY_DELAYS_MS.length - 1);
  return BOOTSTRAP_RETRY_DELAYS_MS[index];
}

export function shouldShowResumeLoading({
  loading = false,
  error = null,
  isOnline = true,
  isVisible = true,
  resumeInFlight = false,
} = {}) {
  return Boolean(isVisible && isOnline && !resumeInFlight && !loading && !error);
}
